import React, { useEffect, useRef, useState, useContext } from "react";
import Profile from "../Profile";
import ErrorBoundary from "../ErrorBoundary";
import { useLocation, Link } from "react-router-dom";
import { GeneralDataContext } from "../../store/GeneralContext";
import { GlobalContext } from "components/AppProvider";
import Notification from "components/Notification";
import { PageTemplateProps } from "./PageTemplate.props";
import "./style.scss";

//TODO: check where is used and rename
// TODO: put title into list of titles
const PageTemplate = React.memo<PageTemplateProps>(
    ({
        children,
        groupName,
        title,
        mainTitle,
        operationLink,
        operationLinkTitle,
        isNewBackground = false,
        listOfTitles,
        customStylePageTemplate,
    }) => {
        const scrollWarp = useRef(null);
        const [isBigRes, setIsBigRes] = useState(false);
        const ordersPage = useLocation()?.pathname?.includes("daily") || false;
        const [states] = useContext(GlobalContext);
        const { showNotification, sidebarPref } = states;
        const generalContext = useContext(GeneralDataContext);
        const {
            expandTable: { numberOfHubs },
        } = generalContext;

        useEffect(() => {
            const windowWidth = window.innerWidth;
            if (
                ordersPage &&
                numberOfHubs &&
                windowWidth / numberOfHubs > 185
            ) {
                setIsBigRes(true);
            } else if (
                ordersPage &&
                numberOfHubs &&
                windowWidth / numberOfHubs < 185
            ) {
                setIsBigRes(false);
            }
        }, [numberOfHubs, ordersPage]);

        return (
            <div
                className="page-template"
                data-testid="page-template"
                style={{
                    width: sidebarPref
                        ? "calc(100% - 60px)"
                        : "calc(100% - 280px)",
                }}
            >
                <div className="bread-crumb">
                    <div className="title-container">
                        <h5 className="group-name" data-testid="group-name">
                            {groupName} /
                        </h5>
                        <h5 className="page-title" data-testid="page-title">
                            {title} {!!listOfTitles?.length ? "/" : ""}
                        </h5>
                        {listOfTitles?.map((item, index) => {
                            return (
                                <h5
                                    className="page-title"
                                    data-testid="page-title"
                                >
                                    {`${item} ${
                                        index === listOfTitles.length - 1
                                            ? ""
                                            : "/"
                                    }`}
                                </h5>
                            );
                        })}
                    </div>
                    {/* <Noruz className="norroz" /> */}
                    {showNotification && <Notification />}
                    {operationLink && (
                        <Link
                            className="kitchen-btn solid is-green oparation-link"
                            to={operationLink}
                        >
                            {operationLinkTitle}
                        </Link>
                    )}
                    <Profile />
                </div>
                <div
                    ref={scrollWarp}
                    className={`${customStylePageTemplate} page-template-content  flex-1 rtl ${
                        isBigRes ? "isBigRes" : ""
                    }${isNewBackground ? "new-background" : "bg-white"}`}
                >
                    {mainTitle && (
                        <h3 className="main-title" data-testid="main-title">
                            {mainTitle}
                        </h3>
                    )}
                    <ErrorBoundary>{children}</ErrorBoundary>
                </div>
            </div>
        );
    }
);

export default PageTemplate;
